<template>
  <div class="orders page">
    <div class="page-header">
      <div class="container">
        <h1 class="title">{{ $t('pagetitle.orders') }}</h1>
      </div>
    </div>
    <div class="page-body" v-loading="loading">
      <div class="container" v-if="tableData.length > 0">
        <div
          v-if="($mq.resize && $mq.below('767px'))">
          <div class="order-list" v-for="(item, index) in tableData" :key="index">
            <div class="list-header">
              <div class="header-left">
                PO: <span class="link" @click="onViewClick(index, item)">{{ item.po_number }}</span>
              </div>
              <div class="header-right">
                {{ item.date }}
              </div>
            </div>
            <div class="list-body">
              <div class="body-left">
                <span>Order Status: {{ item.orderStatus }}</span>
                <span>Total: {{ item.totalprice }}</span>
              </div>
              <div class="body-right">
                <el-button v-if="item.popdf" class="orange-download-button" @click="onDownloadClick(index, item)">
                  {{ $t('button.download') }}
                </el-button>
                <!-- <el-button class="orange-download-button" @click="onViewClick(index, item)">
                  {{ $t('button.view') }}
                </el-button> -->
              </div>
            </div>
          </div>
        </div>
        <el-table
          v-if="!($mq.resize && $mq.below('767px'))"
          :data="tableData"
          style="width: 100%"
          :highlight-current-row="false">
          <el-table-column
            min-width="150"
            prop="po_number"
            label="Purchase Order">
          </el-table-column>
          <!-- <el-table-column
            prop="customer_po_number"
            label="Customer PO">
          </el-table-column> -->
          <el-table-column
            min-width="110"
            prop="date"
            label="Date">
          </el-table-column>
          <el-table-column
            min-width="110"
            prop="orderStatus"
            label="Status">
          </el-table-column>
          <el-table-column
            min-width="110"
            prop="totalprice"
            label="Order total">
          </el-table-column>
          <el-table-column
            min-width="80"
            align="center"
            :label="'PO Download'">
            <template slot-scope="scope">
              <el-button v-if="scope.row.popdf" class="orange-download-button" @click="onDownloadClick(scope.$index, scope.row)">
                {{ $t('button.download') }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            min-width="60"
            align="center">
            <template slot-scope="scope">
              <el-button class="orange-download-button" @click="onViewClick(scope.$index, scope.row)">
                {{ $t('button.view') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="center">
          <el-pagination
            class="pagination"
            background
            layout="prev, pager, next"
            :page-size="pagesize"
            :total="total"
            :pager-count="($mq.resize && $mq.below('767px')) ? 5 : 7"
            :current-page="currentpage"
            @current-change="onPageChange">
          </el-pagination>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Site from '@/api/site'
export default {
  name: 'orders',
  components: {
  },
  props: {
    page: {
      default: 1
    }
  },
  watch: {
    page () {
      this.onLoad()
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      orderStatus: [
        'Pending',
        'Processing',
        'Completed',
        'Closed',
        'Cancelled',
        'On Hold'
      ],
      pagesize: 0,
      total: 0,
      lastpage: 1,
      currentpage: 1
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      this.loading = true
      const data = { id: this.$store.getters.id }
      Site.getUserOrdersById(this.page, data).then((res) => {
        this.total = res.result.total
        this.pagesize = res.result.per_page
        this.lastpage = res.result.last_page
        this.currentpage = res.result.current_page
        res.result.data.forEach((item) => {
          const locale = this.$moment(item.created_at + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY')
          item.date = locale
          item.totalprice = this.$t('currency.malaysia') + ' ' + item.total_amount.toFixed(2)
          item.orderStatus = this.orderStatus[item.status]
        })
        this.tableData = res.result.data
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    onPageChange (page) {
      // this.page = page
      // this.onLoad()
      this.$router.push({ path: `/profile/orders`, query: { page } })
    },
    onViewClick (index, val) {
      const id = val.id
      this.$router.push({ path: '/profile/orders/details', query: { id } })
    },
    onDownloadClick (index, val) {
      if (val.popdf && val.popdf.path) {
        window.open(val.popdf.path, '_blank')
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/settings.scss";
.orders {
  .el-table thead {
    & > tr > th {
      border-bottom: 1px solid $dark-gray-color;
      & > .cell {
        color: $dark-gray-color;
      }
    }
  }
  .el-table__body-wrapper {
    padding-bottom: 1px;
  }
  .el-table__row {
    & > td {
      border-bottom: 1px solid $gray-color;
      & > .cell {
        color: $dark-gray-color;
      }
    }
  }
  .el-table, .el-table th, .el-table tr {
    background-color: transparent;
  }
}
</style>
<style lang="scss" scoped>
.orders {
  .page-body {
    .container {
      padding: 50px 0;
    }
  }
  .orange-button {
    padding: 15px;
  }
  .order-list {
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    border: 1px solid #ddd;
    margin-bottom: 5px;
    font-size: 14px;
    .link {
      cursor: pointer;
      text-decoration: underline;
    }
    .orange-download-button {
      padding: 5px 10px;
    }
    .list-header, .list-body {
      display: flex;
      justify-content: space-between;
    }
    .list-header {
      flex-direction: row;
      padding: 5px 10px;
      background-color: #fff;
      border-radius: 5px 5px 0 0;
    }
    .list-body {
      border-radius: 0 0 5px 5px;
      flex-direction: column;
      background-color: #f5f5f5;
      padding: 7px 10px;
      .body-left {
        padding-bottom: 10px;
        & > span {
          display: block;
        }
      }
      .body-right {
        text-align: right;
        & > span {
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orders/index.vue